const HYDRATE_USER_DATA = '@auth/HYDRATE_USER_DATA';
const HYDRATE_USER_DATA_SUCCESS = '@auth/HYDRATE_USER_DATA_SUCCESS';
const HYDRATE_USER_DATA_FAILED = '@auth/HYDRATE_USER_DATA_FAILED';
const UPDATE_USER_BRANCH = '@auth/UPDATE_USER_BRANCH';

export default {
  HYDRATE_USER_DATA,
  HYDRATE_USER_DATA_SUCCESS,
  HYDRATE_USER_DATA_FAILED,
  UPDATE_USER_BRANCH,
};
